import React from 'react';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation(['common']);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-transparent w-full py-3 px-6">
      <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center">
        <div className="text-sm font-bold text-neobrutalism-text mb-3 sm:mb-0">
          {t('footer.copyright', { year: currentYear })}
        </div>
        <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0">
          <div className="flex space-x-3 mb-3 sm:mb-0 sm:mr-6">
            <a 
              href="/terms-of-service" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-xs text-neobrutalism-text hover:underline"
            >
              {t('legal.termsOfService')}
            </a>
            <span className="text-neobrutalism-text">|</span>
            <a 
              href="/privacy-policy" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-neobrutalism-text hover:underline"
            >
              {t('legal.privacyPolicy')}
            </a>
            <span className="text-neobrutalism-text">|</span>
            <a 
              href="/return-and-cancel-policy" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-neobrutalism-text hover:underline"
            >
              {t('legal.returnAndCancelPolicy')}
            </a>
            <span className="text-neobrutalism-text">|</span>
            <a 
              href="/cookie-policy" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-neobrutalism-text hover:underline"
            >
              {t('legal.cookiePolicy')}
            </a>
          </div>
          <div className="flex items-center space-x-4">
            <img 
              src="/images/piraeus-yellow.png" 
              alt="Piraeus Bank" 
              className="h-[35px] object-contain"
            />
            <img 
              src="/images/verified-by-visa.png" 
              alt="Verified by Visa" 
              className="h-[35px] object-contain"
            />
            <img 
              src="/images/mastercard-securecode.png" 
              alt="Mastercard SecureCode" 
              className="h-[35px] object-contain"
            />
          </div>
        </div>
      </div>
    </footer>
  );
} 